import { useMemo } from 'react';

import { RingTableFilterData } from 'business/production-and-performance/pages/ring-table';
import { RingsTableContainer } from 'business/production-and-performance/pages/ring-table/components/ring-table-container';
import { RingTableColumnKeys } from 'business/production-and-performance/pages/ring-table/types';
import { TableParamsProps } from 'business/providers/table-params';
import { FilterDataSetter } from 'technical/filter-data';

const defaultCurrentPage = 1;
const defaultPageSize = Infinity;

const defaultOrderBy = {
  sortOrder: 'descend',
  sortField: RingTableColumnKeys.RingNumber,
} as const;

export const MobileRingsTableWithPagination = ({
  setFilterData,
}: {
  setFilterData: FilterDataSetter<RingTableFilterData>;
}) => {
  const tableParams = useMemo(() => {
    return {
      current: defaultCurrentPage,
      pageSize: defaultPageSize,
      ...defaultOrderBy,
      position: ['none'],
    } satisfies TableParamsProps;
  }, []);

  return (
    <RingsTableContainer
      tableParams={tableParams}
      setFilterData={setFilterData}
    />
  );
};
